import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0005',
    ecrans: ['00-2'],
    params: ['?vecdistypdis', '?disdat']
});
